import DOMPurify from 'dompurify'

// instance
const Purifier = DOMPurify

// settings
const config = {
  ADD_TAGS: ['script'],
  FORCE_BODY: true,
}
Purifier.setConfig(config)

// hooks
Purifier.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'script') {
    const script = node
    // Avoiding script injections by converting script into a text node
    const content = script.outerHTML
    const container = document.createElement('code')
    container.textContent = content
    return node.parentElement.replaceChild(container, script)
  }
})

export default Purifier
